import api from './client';
import type { TrackerFlow, FlowOffer } from './tracker-types';

export const getFlows = (campaignId?: string) =>
  api.get<TrackerFlow[]>(`/admin/tracker/flows${campaignId ? `?campaign_id=${campaignId}` : ''}`);
export const getFlow = (id: string) => api.get<TrackerFlow>(`/admin/tracker/flows/${id}`);
export const createFlow = (data: Partial<TrackerFlow> & { campaign_id: string; name: string }) =>
  api.post<TrackerFlow>('/admin/tracker/flows', data);
export const updateFlow = (id: string, data: Partial<TrackerFlow>) =>
  api.put<TrackerFlow>(`/admin/tracker/flows/${id}`, data);
export const deleteFlow = (id: string) => api.delete<{ message: string }>(`/admin/tracker/flows/${id}`);

export const getFlowOffers = (flowId: string) =>
  api.get<FlowOffer[]>(`/admin/tracker/flows/${flowId}/offers`);
export const attachOffer = (flowId: string, offer_id: string, priority = 100) =>
  api.post<FlowOffer>(`/admin/tracker/flows/${flowId}/offers`, { offer_id, priority });
export const updateFlowOffer = (linkId: string, data: { priority?: number; status?: string }) =>
  api.put<FlowOffer>(`/admin/tracker/flows/offers/${linkId}`, data);
export const deleteFlowOffer = (linkId: string) =>
  api.delete<{ message: string }>(`/admin/tracker/flows/offers/${linkId}`);
